<template>
  <div>
    <vcr-data-table
      :title="i18n.t('/Vcr/Accessory Tables/Extra/Title')"
      :items="accessoriesWithCategories('DealerAccessories')"
    />

    <vcr-data-table
      :title="i18n.t('/Vcr/Accessory Tables/Delivery Cost/Title')"
      :items="accessoriesWithCategories('DeliveryCosts')"
    />

    <vcr-data-table
      :title="i18n.t('/Vcr/Accessory Tables/Correction/Title')"
      :items="accessoriesWithCategories('Corrections')"
    />
  </div>
</template>

<script>
import VcrDataTable from '@/components/generic/presentational/organisms/vcr/VcrDataTable.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    VcrDataTable,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      accessoriesWithCategories: 'quote/accessoriesWithCategories',
    }),
  },
}
</script>
